import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '../../i18n'
import { getFontSize } from '../../utils/cssUtils'
import { detailClickFaq } from '../../utils/dataTracker'

const FaqLinkWrapper = styled.p`
  font-size: ${getFontSize('body1')};
`

const FaqLink = () => {
  const { t } = useTranslation('common')
  return (
    <FaqLinkWrapper>
      <a
        rel='noreferrer'
        target='_blank'
        onClick={detailClickFaq}
        href={process.env.HK01_FAQ_URL}
      >
        {t('enrollment.donationProcedure')}
      </a>
    </FaqLinkWrapper>
  )
}

export default FaqLink
